<template>
 <div>
    <concession-dashboard v-if="hasPermissionDashboardConssesion"/>
 </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import ConcessionDashboard from 'src/modules/concession-dashboard/ConcessionDashboard.vue'
import { repository } from 'src/jtech'
@Component({
  components: {
    ConcessionDashboard
  }
})
export default class InitPage extends Vue {
  hasPermissionDashboardConssesion = false;
  async mounted () {
    const response = await repository.resolveLogic('userWaste.obterDefaultPage')
    this.hasPermissionDashboardConssesion = response.defaultPage === 'concessionDashboard'
  }
}
</script>

<style>
</style>
